function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0a54a6;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M160.526,186.272a16.8,16.8,0,0,1-1.135-3.732c-.176-2.627-.052-5.273-.052-8.086-13.47-2.414-21.684-10.137-24.177-24.059-2.463,0-4.988.026-7.511-.01a5.151,5.151,0,0,1-2.656-.337c-.752-.536-1.609-1.731-1.485-2.476a3.008,3.008,0,0,1,2.208-1.829c3.078-.216,6.179-.085,9.388-.085,2.47-13.628,10.173-21.946,24.229-24.223,0-2.862.043-5.757-.016-8.655-.033-1.655.37-3.042,2.228-3.111s2.46,1.348,2.489,2.951c.056,2.9.016,5.8.016,8.806,13.853,2.332,21.56,10.546,24.062,24.223,2.663,0,5.391-.121,8.1.052a16.539,16.539,0,0,1,3.729,1.132v2.192a20.136,20.136,0,0,1-3.974,1.312,27.938,27.938,0,0,1-5.728.026c-1.894-.167-2.424.69-2.777,2.391-2.336,11.184-9.254,18.014-20.189,20.922-1.024.272-2.064.478-3.183.73,0,2.538.17,4.825-.059,7.072a28.309,28.309,0,0,1-1.315,4.8Zm1.155-59.79a21.159,21.159,0,0,0-21.462,21.442,21.5,21.5,0,0,0,20.922,21.514c11.9.291,22.191-10.059,21.943-21.387C182.816,135.919,173.706,126.5,161.681,126.482Z",
  transform: "translate(-123.498 -109.666)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M155.4,129.811a11.953,11.953,0,1,1-11.874-12.1A12.015,12.015,0,0,1,155.4,129.811Zm-4.835-.1a7.118,7.118,0,1,0-7.1,7.072A7,7,0,0,0,150.569,129.713Z",
  transform: "translate(-105.33 -91.403)"
});

var SvgLocationLarge = function SvgLocationLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76.442,
    height: 76.605,
    viewBox: "0 0 76.442 76.605",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location_large.349bfa63.svg";
export { ForwardRef as ReactComponent };